// extracted by mini-css-extract-plugin
export var col = "style-module--col--c3801";
export var colDesc = "style-module--col-desc--8d04f";
export var colIcon = "style-module--col-icon--8f056";
export var result = "style-module--result--b52f8";
export var row = "style-module--row--721b5";